import lang from '../../lang';

const NumberUtil = {
    /**
     * 补0
     * @param  {Number} num    [要处理的数字]
     * @param  {Number} digits [要处理的位数]
     * @example
     *      prefixedNum(1,1); // 01
     *      prefixedNum(1,2); // 001
     */
    prefixed: function(num, digits) {
        var zeroStr = [];
        num = (typeof(num) == 'undefined' ? '' : num);
        for (var i = 0; i < digits; ++i) {
            zeroStr.push(0);
        }

        return zeroStr.join('').substr(0, digits - num.toString().length) + num;
    },
    /**
     * 分隔数字
     * @param  {String|Number} str       [要处理的数字]
     * @param  {String} separator [分隔符号]
     * @example
     *      getSeparatedNum('900020'); // 900,020
     */
    separate: function(str, separator) {
        str = (typeof(str) == 'undefined' ? '' : str) + '';
        separator = separator || ',';

        return str.replace(/(\d+)(\.\d+)?/g, function(num, a, b) {
            return (a.length > 3 ? (a.indexOf(separator) < 0 || a.indexOf(separator) > 3 ? a.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") : a) : a) + (b || '');
        });
    },

    formatDiffTime: function(timeDifference, formatPattern) {
        var self = this;
        var oriFormatPattern = formatPattern,
            timeSlices;
        formatPattern = formatPattern || 'd天h小时m分s秒';
        timeSlices = [{
            pattern: /d+/g,
            rate: 24 * 60 * 60 * 1000
        }, {
            pattern: /h+/g,
            rate: 60 * 60 * 1000
        }, {
            pattern: /m+/g,
            rate: 60 * 1000
        }, {
            pattern: /s+/g,
            rate: 1000
        }, {
            pattern: /f+/g,
            rate: 1
        }];

        for (var i = 0; i < timeSlices.length; ++i) {
            timeSlices[i].value = timeDifference;
            for (var j = 0; j < i; ++j) {
                if (formatPattern.match(timeSlices[j].pattern)) {
                    timeSlices[i].value -= timeSlices[j].value * timeSlices[j].rate;
                }
            }
            timeSlices[i].value = Math.floor(timeSlices[i].value / timeSlices[i].rate);
        }

        for (var i = 0; i < timeSlices.length; ++i) {
            formatPattern = formatPattern.replace(timeSlices[i].pattern, function(matchStr) {
                var subLen = Math.min(matchStr.length, (i == 0 ? Infinity : (i == 4 ? 3 : 2)));
                return self.prefixed(timeSlices[i].value, subLen);
            });
        }

        formatPattern = oriFormatPattern ? formatPattern : formatPattern.replace(/(\d+)(?:天|小时|分|秒|毫秒)/g, function(matchStr, num) {
            return Number(num) ? matchStr : '';
        });

        return formatPattern;
    },

    getDiffTime: function(time) {
        // var now = new Date().getTime();
        // var t;
        // if (typeof time == 'number') {
        //     t = new Date(parseInt(time));
        // } else if (typeof time == 'string') {
        //     t = Number(time) ? arguments.callee(parseInt(time)) : new Date(time.replace(/-/g, '/'));
        // }
        // var val = Math.floor((now - t) / 1000);
        var val = time /  1000;
        var result = '';

        var timeMap = {
            'y': {
                rate: 60 * 60 * 24 * 365
            },
            'M': {
                rate: 60 * 60 * 24 * 30
            },
            'd': {
                rate: 60 * 60 * 24
            },
            'h': {
                rate: 60 * 60
            },
            'm': {
                rate: 60
            }
        };

        for (var i in timeMap) {
            timeMap[i].value = Math.floor(val / timeMap[i].rate);
        }
        
        if (timeMap['y'].value > 0) {
            result = lang.template('<%=num%>年前', { num: timeMap['y'].value});
        } else if (timeMap['M'].value > 0) {
            result = lang.template('<%=num%>月前', { num: timeMap['M'].value});
        } else if (timeMap['d'].value > 0) {
            result = lang.template('<%=num%>天前', { num: timeMap['d'].value});
        } else if (timeMap['h'].value > 0) {
            result = lang.template('<%=num%>小时前', { num: timeMap['h'].value});
        } else if (timeMap['m'].value > 0) {
            result = lang.template('<%=num%>分钟前', { num: timeMap['m'].value});
        } else {
            result = lang.template('刚刚');
        }
        return result;
    },

    uuid(len, radix) {
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var uuid = [], i;
        radix = radix || chars.length;

        if (len) {
            // Compact form
            for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
        } else {
            // rfc4122, version 4 form
            var r;

            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';

            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random()*16;
                    uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                }
            }
        }

        return uuid.join('');
    }
};

export default NumberUtil;



// WEBPACK FOOTER //
// ./js/lib/util/number.js